import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[radioItemHtmlLabel]',
})
export class RadioItemHtmlLabelDirective implements AfterViewInit {
  @Input('customRadioHtmlLabel') htmlContent!: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    setTimeout(() => {
      // Find label element inside goa web component
      const gotRadioItemEl =
        this.el.nativeElement.querySelector('goa-radio-item')?.shadowRoot;

      if (gotRadioItemEl) {
        const labelEl = gotRadioItemEl.querySelector(
          'div > label > span.label'
        ) as HTMLLabelElement;

        if (labelEl && this.htmlContent) {
          this.renderer.setProperty(labelEl, 'innerHTML', this.htmlContent);
        }
      }
    }, 0);
  }
}
